import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import CountryPicker from "./CountryPicker";
import PhoneInput from "./PhoneInput";
import { Country } from "../../../types";

type Props = {
  country: Country;
  phone: string;
  setPhone: (phone: string) => void;
};

export default function PhoneAndCountry({ country, phone, setPhone }: Props) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row items-center")}>
      <View style={tailwind("mr-3")}>
        <CountryPicker selectedCountry={country} />
      </View>
      <PhoneInput
        countryCode={country.code}
        phone={phone}
        setPhone={setPhone}
      />
    </View>
  );
}
